import React, { useState } from 'react';
import classes from "./styles.module.scss";
import Title from '@/ui/Title';
import { specialisms_helper } from '@/helpers/specialisms_helper';
import SpecialismTile from './SpecialismTile';
import { replace } from 'lodash';

const SpecialismCategories = ({ className, label, parentId, slug }) => {
  const items = specialisms_helper.fetch({parent: parentId, filter: filterSpecialisms});
  const [activeIndex, setActiveIndex] = useState(0);

  function filterSpecialisms(item) {
    return replace(item.link, "/specialism/", "") != slug;
  }

  const handleClick = (index) => {
    if(index == activeIndex) {

    } else {
      setActiveIndex(index);
    }
  }

  return (
    <div className={`${classes.specialisms} ${className}`}>
      <div className={classes.header}>
        <Title tag="h3" title={label} className={`h2`} highlight={false} variant="quaternary" />
      </div>
      <div className={classes.tiles} >
        {items.map((item, k) => (
          <SpecialismTile key={k} item={item} index={k} activeIndex={activeIndex} handleClick={handleClick} />
        ))}
      </div>
    </div>
  )
}

export default SpecialismCategories